export default "__VITE_ASSET__ODw0Jezds0q2jFaKUjcEHQ__"